<template>
    <div>
        <div  class="bg-white pb-6"  style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; height: auto;">
            <div class="fs-14 fw-500 px-8 bg-color py-2 mb-4">Helpdesk Ticket Info</div>
            <div  class="d-flex justify-content-between align-items-center px-8">
                <div>
                    <span class="fw-600 fs-14">List of Helpdesk Ticket attached with this Meetings:</span>
                </div>
                <div>
                    <button class="btn btn-new-green btn-wide px-6" > + Helpdesk Ticket</button>
                </div>
            </div>
            <div class="table-block overflow-x-auto mt-1 px-8 py-4" style="background-color:#fff;border-radius:5px">
                <!-- <div class="header-outer" v-if="!ajaxCallInProgress && teams.length == 0">
                    <span class="fw-500" v-if="teamLogin == 'My Team'">My Team</span>
                    <span class="fw-500" v-if="teamLogin == 'Team Member'">Team Member</span>
                </div> -->
                <!-- Table List View -->
                <table class="schedule-list-table table-responsive w-100">
                    <thead >
                        <tr>
                            <th width="10">TICKET ID</th>
                            <th width="15%">STATUS</th>
                            <th width="15%">SUBJECT</th>
                            <th width="20%">TICKET CREATOR</th>
                            <th width="20%">DATE CREATED</th>
                            <th width="20%">ASSIGNED TO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr v-if="!ajaxCallInProgress" class="text-center font-weight-bold" style="height: 400px;">
                            <td colspan="7" class="w-1 font-weight-bold pb-4 pt-4">
                                <img src="/static/images/schedule-illus.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                <div class="text-center"> No Meeting is scheduled.<span style="color: #00448b;" class="pointer" @click="createSchedule()"> Add here</span></div>
                            </td>
                        </tr> -->
                        <tr>
                            <td width="10%" class="pointer">
                                <span style="color: #00448b;">#52130</span>
                            </td>
                            <td width="15%">
                                <span class="re-open px-3">Re-open</span>
                            </td>
                            <td width="15%">
                                <span>CRM Review</span>
                            </td>
                            <td width="20%">
                                <span>Sam Mike</span>
                            </td>
                            <td width="20%">
                                <span>01/30/2024 9:00 AM</span>
                            </td>
                            <td width="20%">
                                <span>Kevin joy</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Pagination Section -->
            <div v-if="!ajaxCallInProgress" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                    :options="pageLimit" :close-on-select="true" v-model.number="limit"
                    :max-height="210" :allow-empty="false" :searchable="false"
                    open-direction="top" :show-labels="false" placeholder=""
                    style="width: 4.2em !important;padding-right: 10px!important;">
                </multiselect>
                <span class="page-info pr-6 fw-500 text-dark font-size-small">Per page</span>
                <button @click="firstPage()" class="mt-1 pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
    data(){
        return{
            success_msg: '',
            warning_msg: "",
            ajaxCallInProgress: false,
            limit: 10,
            skip: 0,
            pageLimit: [],
            total: 0,
            skip_temp:0,
            temp_total:0,
            count: 0,
        }
    },
    mixins:[],
    components: {
    },
    mounted(){
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        
    },
    created() {
       
    },
    computed: {
        getSkipCount() {
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    watch: {
    },
}
</script>
<style>
    .bg-color{
        background-color: #00448b;
        color:#fff !important;
        border-radius: 4px;
    }
    .schedule-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 33px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .schedule-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .schedule-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .schedule-list-table tbody tr td {
        background: #fff;
        padding: 10px 33px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .schedule-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .re-open{
        background-color: #e6a653;
        border-radius: 10px;
        padding: 4px;
        color: #fff;
        font-size: 10px;
    }
    .open-ticket{
        background-color: #ff7174;
        border-radius: 10px;
        padding: 4px;
        color: #fff;
        font-size: 10px;
    }
    .closed{
        background-color: #2ecc71;
        border-radius: 10px;
        padding: 4px;
        color: #fff;
        font-size: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ScheduleMeeting/HelpDeskTab.vue